import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DomainPrebidModuleAttributesErrors } from './types'

export const DOMAIN_PREBID_MODULE_ATTRIBUTES_ERRORS_FRAGMENT: TypedDocumentNode<DomainPrebidModuleAttributesErrors> = gql`
  ${ERROR_FRAGMENT}

  fragment DomainPrebidModuleAttributesErrorsFragment on DomainPrebidModulesErrors {
    domainPrebidModuleId
    errors {
      ...ErrorFragment
    }
  }
`
